export default __webpack_public_path__ + "static/media/flag-saint-helena.519d9847.svg";